/**
 * Central persistence + bootstrap helpers for admin dashboard dark mode.
 *
 * Duplicated in a tiny inline script in `public/index.html` so `data-theme`
 * exists before the React bundle executes (first paint / FOUC). Keep paths in sync.
 */

export const ADMIN_THEME_LS_KEY = "edutopia_admin_theme";
export const ADMIN_THEME_SS_KEY = "edutopia_admin_theme";

export function readAdminThemePreference() {
  if (typeof window === "undefined") return "light";
  try {
    const ls = window.localStorage.getItem(ADMIN_THEME_LS_KEY);
    if (ls === "dark") return "dark";
    if (ls === "light") return "light";
    const ss = window.sessionStorage.getItem(ADMIN_THEME_SS_KEY);
    if (ss === "dark") return "dark";
    if (ss === "light") return "light";
  } catch {
    /* quota / disabled storage */
  }
  return "light";
}

export function writeAdminThemePreference(mode) {
  const normalized = mode === "dark" ? "dark" : "light";
  try {
    window.localStorage.setItem(ADMIN_THEME_LS_KEY, normalized);
    window.sessionStorage.setItem(ADMIN_THEME_SS_KEY, normalized);
  } catch {
    /* ignore */
  }
}

export function applyAdminThemeToHtml(mode) {
  if (typeof document === "undefined") return;
  if (mode === "dark") {
    document.documentElement.setAttribute("data-theme", "dark");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
}

/**
 * True when the URL corresponds to pages that use `Layout` / admin chrome.
 * Uses substring checks so nested deploy paths like `/app/dashboard/...` still work.
 */
export function isAdminShellLocation(pathname = "", hash = "") {
  const p = pathname || "";
  const h = hash || "";
  if (p.includes("/dashboard")) return true;
  if (p.includes("/super-admin/dashboard")) return true;
  if (p.includes("/scan-code")) return true;
  if (h && (h.includes("dashboard") || h.includes("super-admin"))) return true;
  return false;
}

/** Run synchronously from `src/index.js` before ReactDOM.createRoot. */
export function bootstrapAdminThemeBeforeReact() {
  if (typeof window === "undefined") return;
  try {
    const { pathname, hash } = window.location;
    if (!isAdminShellLocation(pathname, hash)) return;
    if (readAdminThemePreference() === "dark") {
      document.documentElement.setAttribute("data-theme", "dark");
    }
  } catch {
    /* ignore */
  }
}

/**
 * `localStorage.clear()` wipes the theme key; several auth paths call it.
 * Preserve preference across clears so reload / logout does not reset UI theme.
 */
export function preserveAdminThemeDuringClear(clearFn) {
  const saved = readAdminThemePreference();
  clearFn();
  writeAdminThemePreference(saved);
}
